import React from "react";
import { Card, Image, Space, Typography } from "antd";
import { FilePdfOutlined, EyeOutlined } from "@ant-design/icons";
import { ModalBase } from "../../../../../Components/Modais/ModalBase/ModalBase";
import ButtonActions from "../../../../../Components/Buttons/ButtonActions/ButtonActions";

const { Text } = Typography;

const handleOpenDocument = (url) => {
  window.open(url, "_blank");
};

const DocumentPreview = ({ document, documentUrl }) => {
  if (!document?.s3_key) return <Text>Nenhum documento anexado</Text>;

  if (document?.content_type.startsWith("image/")) {
    return (
      <Card bordered={false} style={{ width: 500 }}>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Image width={500} src={documentUrl} alt="Exemplo de Documento" />
        </div>
      </Card>
    );
  }

  if (document?.content_type === "application/pdf") {
    return (
      <Card
        hoverable
        onClick={() => handleOpenDocument(documentUrl)}
        style={{
          width: 300,
          textAlign: "center",
          cursor: "pointer",
        }}
      >
        <Space direction="vertical" size="middle">
          <FilePdfOutlined
            style={{
              fontSize: 80,
              color: "#ff4d4f",
            }}
          />

          <Text strong>{document.pdf}</Text>

          <Text type="secondary">
            <EyeOutlined /> Clique para visualizar
          </Text>
        </Space>
      </Card>
    );
  }

  return (
    <Card>
      <Text>Formato não suportado para visualização.</Text>
    </Card>
  );
};

const ModalViewDocument = ({
  open,
  onClose,
  onApprove,
  onReject,
  selectedDocument,
}) => {
  return (
    <ModalBase
      animated={false}
      open={open}
      onCancel={onClose}
      title="Documento enviado"
      width={800}
      footerAlign="center"
      footer={
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "16px",
            width: "100%",
          }}
        >
          <ButtonActions variant="primary" onClick={onReject} text="RECUSAR" />
          <ButtonActions variant="danger" onClick={onApprove} text="APROVAR" />
        </div>
      }
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "500px",
        }}
      >
        <DocumentPreview
          document={selectedDocument?.document}
          documentUrl={selectedDocument?.document_url}
        />
      </div>
    </ModalBase>
  );
};

export default ModalViewDocument;
